module.exports = __webpack_public_path__ + "afd649fd.svg";